"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var Footer = function Footer(props) {
  return _react.default.createElement(_UIFlex.default, (0, _extends2.default)({}, props, {
    align: "baseline",
    justify: "between",
    wrap: "wrap"
  }));
};

var _default = Footer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/cards/Footer.js
// module id = 437
// module chunks = 209 210 211 212